module.exports = ":host {\n  z-index: 1; }\n"